// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3XbAL","footer":"ModalError_footer__1EFM2"};